/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from 'react';
import { H2sApi } from '../../utils/api';
import { Toast } from 'primereact/toast';
import { Styles, StyledSectionButton } from './h2sStyle';
import {
  reformatDate,
  formatStringToDate,
  ShowDataCalcul,
  FieldObservation,
  ShowInspection,
} from './helper';
import { formType } from './Interface';
import moment from 'moment';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import { loaderDataComponent } from '../../utils/helper';

declare type Props = {
  mainInstallCode: string;
};

const H2SParam = ({ mainInstallCode }: Props) => {
  //création des variables
  const todayDateTime = moment(Date.now()).toDate();
  const today = {
    year: todayDateTime.getFullYear(),
    month: todayDateTime.getMonth() + 1,
    day: todayDateTime.getDate(),
  };
  const toast = useRef<any>(null);
  const [dataList, setDataList] = React.useState<any>();
  const [showErrorMessage, setShowErrorMessage] = React.useState<any>({
    bach: false,
    notationGrill: false,
  });
  const [itvDate, setItvDate] = React.useState<any>();
  const [lastVisitDate, setLastVisitDate] = React.useState<any>();
  const [lastMeasurementDate, setLastMeasurementDate] = React.useState<any>();
  const [form, setForm] = React.useState<formType>({
    aggravatingFactor: dataList?.aggravatingFactor,
    averageTemp: dataList?.averageTemp,
    bachNumber: dataList?.bachNumber,
    bachVolume: dataList?.bachVolume,
    treatmentType: dataList?.treatmentType,
    civilEngDegrad: dataList?.civilEngDegrad,
    civilEngDegradComment: dataList?.civilEngDegradComment,
    factorComment: dataList?.factorComment,
    crack: dataList?.crack,
    compressor: dataList?.compressor,
    concreteAlteration: dataList?.concreteAlteration,
    flowMesure: dataList?.flowMesure,
    dco: dataList?.dco,
    id: dataList?.id,
    itv: dataList?.itv,
    itvDate: dataList?.itvDate,
    lastVisitDate: dataList?.lastVisitDate,
    lastMeasurementDate: dataList?.lastMeasurementDate,
    treatmentDevice: dataList?.treatmentDevice,
    colPoolSmellSensitivity: dataList?.colPoolSmellSensitivity,
    itvComment: dataList?.itvComment,
    mainInstallCode: dataList?.mainInstallCode,
    qualiMeasure: dataList?.qualiMeasure,
    qualiMeasureComment: dataList?.qualiMeasureComment,
    siteVisit: dataList?.siteVisit,
    siteVisitComment: dataList?.siteVisitComment,
    smellDevice: dataList?.smellDevice,
    smellObservation: dataList?.smellObservation,
    smellSensitivity: dataList?.smellSensitivity,
    tamponCorrosion: dataList?.tamponCorrosion,
  });
  const [loading, setLoading] = React.useState(false);

  const getParameters = async () => {
    setLoading(true);
    try {
      const response = await H2sApi.getH2sParameters(mainInstallCode);
      setDataList(response.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  //useEffects
  useEffect(() => {
    getParameters();
  }, []);

  useEffect(() => {
    if (dataList?.itvDate) {
      setItvDate(formatStringToDate(dataList?.itvDate));
    }
    if (dataList?.lastMeasurementDate) {
      setLastMeasurementDate(formatStringToDate(dataList?.lastMeasurementDate));
    }
    if (dataList?.lastVisitDate) {
      setLastVisitDate(formatStringToDate(dataList?.lastVisitDate));
    }
    setForm(dataList);
  }, [dataList]);

  useEffect(() => {
    if (
      (form?.bachNumber === null && form?.bachVolume === null) ||
      (form?.bachNumber !== null && form?.bachVolume !== null)
    ) {
      setShowErrorMessage((oldValues: any) => {
        return { ...oldValues, bach: false };
      });
    } else {
      setShowErrorMessage((oldValues: any) => {
        return { ...oldValues, bach: true };
      });
    }
  }, [form]);

  const handleOnSubmit = async () => {
    let isValid = true;
    if (showErrorMessage.bach || showErrorMessage.notationGrill) {
      isValid = false;
    }
    if (isValid) {
      setLoading(true);
      try {
        if (itvDate) {
          form.itvDate = reformatDate(itvDate);
        }
        if (lastVisitDate) {
          form.lastVisitDate = reformatDate(lastVisitDate);
        }
        if (lastMeasurementDate) {
          form.lastMeasurementDate = reformatDate(lastMeasurementDate);
        }
        const response = await H2sApi.updatesH2sParameters({
          aggravatingFactor: form?.aggravatingFactor,
          averageTemp: form?.averageTemp,
          bachNumber: form?.bachNumber,
          bachVolume: form?.bachVolume,
          treatmentType: form?.treatmentType,
          civilEngDegrad: form?.civilEngDegrad,
          civilEngDegradComment: form?.civilEngDegradComment,
          factorComment: form?.factorComment,
          crack: form?.crack,
          compressor: form?.compressor,
          concreteAlteration: form?.concreteAlteration,
          flowMesure: form?.flowMesure,
          dco: form?.dco,
          id: form?.id,
          itv: form?.itv,
          itvDate: form?.itvDate,
          lastVisitDate: form?.lastVisitDate,
          lastMeasurementDate: form?.lastMeasurementDate,
          treatmentDevice: form?.treatmentDevice,
          colPoolSmellSensitivity: form?.colPoolSmellSensitivity,
          itvComment: form?.itvComment,
          qualiMeasure: form?.qualiMeasure,
          qualiMeasureComment: form?.qualiMeasureComment,
          siteVisit: form?.siteVisit,
          siteVisitComment: form?.siteVisitComment,
          smellDevice: form?.smellDevice,
          smellObservation: form?.smellObservation,
          smellSensitivity: form?.smellSensitivity,
          tamponCorrosion: form?.tamponCorrosion,
        });
        if(response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: 'Succès',
            detail: 'Données de paramètre enregistrées',
            life: 5000,
          });
        }
      } catch (e) {
        toast.current?.show({
          severity: 'error',
          summary: 'Erreur',
          detail:
            "Erreur lors de l'enregistrement des données de paramètre enregistrées",
          life: 5000,
        });
      } finally {
        setLoading(false);
      }
    }
  }
  return (
    <Container
      automatedTestId='h2s-global-container'
      className='h2s-global-container sds-reset-style'
    >
      <Styles />
      <Toast ref={toast} />
      <Form onSubmit={handleOnSubmit}>
        <Container className='global-card-container'>
          <Container className='data-container'>
            <ShowDataCalcul
              form={form}
              setForm={setForm}
              showErrorMessage={showErrorMessage}
            />
          </Container>
          <Container className='data-container'>
            <FieldObservation
              form={form}
              setForm={setForm}
              showErrorMessage={showErrorMessage}
              setLastMeasurementDate={setLastMeasurementDate}
              setLastVisitDate={setLastVisitDate}
              lastMeasurementDate={lastMeasurementDate}
              today={today}
              lastVisitDate={lastVisitDate}
            />
          </Container>
          <Container className='inspection-container'>
            <ShowInspection
              form={form}
              setForm={setForm}
              setItvDate={setItvDate}
              itvDate={itvDate}
              today={today}
            />
          </Container>
        </Container>
        <Container className='h2sButton'>
          {loaderDataComponent(loading, `width: 28px;
            height: 28px;
            border: 5px solid #FFF;
            border-bottom-color: #243977;
            border-radius: 50%;
            margin-top: 2vh;
            display: inline-block;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;`)}
          {loading === false && <StyledSectionButton>
            <Button className='h2s-btn' mode='plain'>
              <Word
                variant='span'
                textStyle='normalBold'
                value='Enregistrer les modifications'
              />
            </Button>
          </StyledSectionButton>}
        </Container>
      </Form>
    </Container>
  );
}

export default H2SParam;
